import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { DevWrapperComponent } from './dev-wrapper';
import { DevBreadcrumbsComponentModule } from '../dev-breadcrumbs/dev-breadcrumbs.module';
import { DevJumbotronComponentModule } from '../dev-jumbotron/dev-jumbotron.module';

@NgModule({
  declarations: [
    DevWrapperComponent,
  ],
  entryComponents: [
    DevWrapperComponent
  ],
  imports: [
    DevBreadcrumbsComponentModule,
    DevJumbotronComponentModule,
    IonicModule,
  ],
  exports: [
    DevWrapperComponent
  ]
})
export class DevWrapperComponentModule { }



// WEBPACK FOOTER //
// ./src/components/dev-wrapper/dev-wrapper.module.ts